import { useState } from 'react'
import { AlertTriangle, ArrowRight } from 'lucide-react'

export default function ProfileBanner({ onNavigate }) {
  const [dismissed, setDismissed] = useState(false)
  if (dismissed) return null

  return (
    <div className="surface p-4 flex items-center gap-4 border-l-2 border-l-brand animate-fade-in">
      <div className="w-9 h-9 bg-brand-soft flex items-center justify-center shrink-0">
        <AlertTriangle size={16} className="text-brand" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-ink">Your profile is incomplete</p>
        <p className="text-xs text-muted mt-0.5">
          Complete founder KYC and business profile to unlock investor visibility and compliance export.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          onClick={() => onNavigate?.('profile')}
          className="btn-primary text-xs flex items-center gap-1.5"
        >
          Go to Profile <ArrowRight size={13} />
        </button>
        <button
          onClick={() => setDismissed(true)}
          className="text-neutral-400 hover:text-ink text-xs px-2"
          aria-label="Dismiss"
        >
          Dismiss
        </button>
      </div>
    </div>
  )
}
